<template>
  <div class="audit-child-title" :class="{'mt0': mt0, 'mb0': mb0}" :style="{'margin-left': marginLeft ? marginLeft : '', 'width': marginLeft ? 'calc(100% - 40px)' : '100%'}">
    <div class="audit-child-icon">

    </div>
    <div class="audit-child-title-text">{{title}}</div>
    <div class="audit-child-line">

    </div>
    <div class="audit-child-remark" v-if="remark">
      {{ remark }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    },
    mt0: {
      type: Boolean,
      default: false
    },
    mb0: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">

.mt0 {
  margin-top: 0 !important;
}

.mb0 {
  margin-bottom: 0 !important;
}

.audit-child-title {
  width: 100%;
  height: 20px;
  position: relative;
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  .audit-child-icon {
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: rgba(76, 192, 253, 1);
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
      height: 100%;
    }
  }

  .audit-child-title-text {
    color: rgba(2, 99, 183, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-left: 12px;
  }

  .audit-child-line {
    margin-left: 16px;
    flex: 1;
    height: 2px;
    //background-color: rgba(233, 234, 236, 1);
    border: 1px dashed rgba(233, 234, 236, 1);
  }

  .audit-child-remark {
    margin-left: 16px;
    color: rgba(72, 157, 217, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
  }
}
</style>